import { motion } from "motion/react";
import { ArrowUpRight } from "lucide-react";

const PROYECTOS = [
  {
    video: "https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260513_220333_48163edc-995f-4513-9f44-48dbb07a7329.mp4",
    title: "Temporada de Salud y Bienestar Barinas 2026",
    desc: "Proyecto insignia. Fusiona inmersión natural, bio-regeneración y turismo médico de alta gama.",
    ods: "ODS 3 - Salud y Bienestar",
    link: "#contacto",
  },
  {
    video: "https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260513_221040_e6ba7c5a-864e-46e9-871e-341a176a7e3e.mp4",
    title: "Global Big Day Barinas 2026",
    desc: "Ciencia ciudadana y aviturismo: Barinas al mapa mundial del avistamiento de aves.",
    ods: "ODS 15 - Vida de Ecosistemas",
    link: "#contacto",
  },
  {
    video: "https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260513_221104_fb538584-5b87-495f-952e-09ddd5a1792a.mp4",
    title: "KupVita - Salus Per Naturam",
    desc: "Ecosistema de turismo de salud y bienestar del llano: médicos, aliados y espacios certificados por el Sello Anfitrión Barinés de CADTEBA. Turismo somos todos.",
    ods: "ODS 3 - Salud y Bienestar",
    link: "https://www.kupvita.com",
    external: true,
  },
  {
    video: "https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260513_220333_48163edc-995f-4513-9f44-48dbb07a7329.mp4",
    title: "IVARY Adventures",
    desc: "Tour operadora de turismo de aventura, naturaleza y relax. Del piedemonte andino a la sabana infinita, con baquianos y guías locales. Naturaleza que inspira, experiencias que transforman.",
    ods: "ODS 8 y 15",
    link: "https://ivary-adventures-454390809705.us-west2.run.app",
    external: true,
  },
];

export const Proyectos = () => {
  return (
    <section id="proyectos" className="max-w-6xl mx-auto px-6 py-24 md:py-32" data-testid="section-proyectos">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="text-center max-w-3xl mx-auto mb-14 md:mb-20"
      >
        <p className="text-xs uppercase tracking-[0.35em] text-[#C6A15B] mb-4">Lo que ya está en marcha</p>
        <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white font-medium mb-5" data-testid="proyectos-title">
          Proyectos que se ejecutan con CADTEBA y sus miembros.
        </h2>
        <p className="text-base md:text-lg text-white/70">
          BHG los diseña y orquesta; la Cámara y su gente los hacen realidad en el territorio.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {PROYECTOS.map((p, i) => (
          <motion.article
            key={p.title}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: (i % 3) * 0.15, ease: "easeOut" }}
            className="liquid-glass rounded-3xl overflow-hidden bg-white/[0.02] flex flex-col"
            data-testid={`proyecto-card-${i + 1}`}
          >
            <div className="relative h-48 overflow-hidden">
              <video
                src={p.video}
                autoPlay
                loop
                muted
                playsInline
                preload="metadata"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A0908] via-transparent to-transparent" />
            </div>
            <div className="p-7 flex flex-col flex-1">
              <span className="inline-block self-start text-[10px] uppercase tracking-[0.2em] text-[#C6A15B] border border-[#C6A15B]/40 rounded-full px-3 py-1 mb-4">
                {p.ods}
              </span>
              <h3 className="font-serif-display text-xl text-white font-medium mb-3">{p.title}</h3>
              <p className="text-sm text-white/60 leading-relaxed mb-6 flex-1">{p.desc}</p>
              <a
                href={p.link}
                target={p.external ? "_blank" : undefined}
                rel={p.external ? "noopener noreferrer" : undefined}
                data-testid={`proyecto-cta-${i + 1}`}
                className="inline-flex items-center gap-2 self-start text-xs uppercase tracking-widest text-[#C6A15B] hover:text-[#d9b876] transition-colors"
              >
                Conozca el proyecto <ArrowUpRight size={14} />
              </a>
            </div>
          </motion.article>
        ))}
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
        className="text-center mt-14"
      >
        <a
          href="#participa"
          data-testid="proyectos-cta-participar"
          className="inline-flex items-center justify-center rounded-full bg-[#C6A15B] px-8 py-3.5 text-sm uppercase tracking-widest text-black font-medium hover:bg-[#d9b876] transition-colors"
        >
          Quiero participar en un proyecto
        </a>
      </motion.div>
    </section>
  );
};
